/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": import.meta.env.VITE_aws_cognito_identity_pool,
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": import.meta.env.VITE_cognito_user_pool_id,
    "aws_user_pools_web_client_id": import.meta.env.VITE_aws_cognito_user_pool_client,
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 15,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [],
    "aws_user_files_s3_bucket": "astorgolga-assets",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};

export default awsmobile;
